import { render, staticRenderFns } from "./ExamInsightTable.vue?vue&type=template&id=789983ed&scoped=true"
import script from "./ExamInsightTable.vue?vue&type=script&lang=js"
export * from "./ExamInsightTable.vue?vue&type=script&lang=js"
import style0 from "./ExamInsightTable.vue?vue&type=style&index=0&id=789983ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789983ed",
  null
  
)

export default component.exports